<template lang="pug">
.resident-group-detail-modal
  b-modal(ref="modal" size="lg" no-close-on-backdrop no-close-on-esc hide-footer)
    .resident-group-detail-modal-header(slot="modal-header" slot-scope="{ cancel }")
      .float-left.title
        span {{ groupName }}
      .float-right
        button(type="button" class="close" @click="cancel()") ×

    .resident-group-detail-modal-table
      .thead
        .header-line
          .th.room 部屋名
          .th.name 利用者名
      .tbody
        .body-line(v-for="groupMember in _value")
          .td.room {{ groupMember.room }}
          .td.name {{ groupMember.name}}
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import { ResidentGroupMembersGetModel } from "@/commons/services/ResidentGroupMembers";

/**
 * 利用者グループにひもづく利用者詳細表示モーダル
 */
@Component
export default class ResidentGroupDetailModal extends Vue {
  /**
   * 利用者グループメンバー
   */
  @Prop({
    default: () => {
      return [];
    }
  })
  private value!: Array<ResidentGroupMembersGetModel>;
  /**
   * 利用者グループ名
   */
  @Prop({
    default: () => {
      return "";
    }
  })
  private groupName!: string;

  /**
   * モーダル表示
   */
  public show(): void {
    const modal: any = this.$refs.modal;
    if (modal) {
      modal.show();
    }

    return;
  }

  get _value(): Array<ResidentGroupMembersGetModel> {
    return this.value;
  }
}
</script>
